// TDIC: lodash imported
import _ from 'lodash';

const normalisedLobIcons = {
    PA: {
        image: 'personal-auto',
        font: 'mi-directions_car'
    },
    HO: {
        image: 'home-owners',
        font: 'mi-home'
    },
    GL: {
    // TDIC: Lob name Changed
    // image: 'general-liability',
        image: 'professional-liability',
        font: 'mi-healing'
    },
    BO: {
        image: 'business-owners',
        font: 'mi-store'
    },
    IM: {
        image: 'inland-marine',
        font: 'mi-directions_boat'
    },
    CP: {
        image: 'commercial-property',
        font: 'mi-unarchive'
    },
    CA: {
        image: 'commercial-auto',
        font: 'mi-local_shipping'
    },
    WC: {
        image: 'workers-comp',
        font: 'mi-work'
    },
    CPKG: {
        image: 'commercial-package',
        font: 'mi-unarchive'
    },
    TRVL: {
        image: 'travel',
        font: 'mi-plane'
    },
    PUL: {
        image: 'no-icon',
        font: 'fa-umbrella'
    },
    PL: {
        image: 'professional-liability',
        font: 'mi-healing'
    },
    CL: {
        image: 'cyber-suite',
        font: 'mi-healing'
    },
    LRP: {
        image: 'lessors-risk',
        font: 'mi-store'
    },
    BOP: {
        image: 'business-owners',
        font: 'mi-store'
    },
    default: {
        image: 'no-icon', // Using an existing empty image as default to avoid 404s
        font: 'mi-receipt'
    }
};

const materialLobIcons = {
    PA: {
        image: 'personal-auto',
        font: 'mi-directions_car'
    },
    HO: {
        image: 'home-owners',
        font: 'mi-home'
    },
    GL: {
        image: 'professional-liability',
        font: 'mi-healing'
    },
    BO: {
        image: 'business-owners',
        font: 'mi-business'
    },
    IM: {
        image: 'inland-marine',
        font: 'mi-directions_boat'
    },
    CP: {
        image: 'commercial-property',
        font: 'mi-apartment'
    },
    CPKG: {
        image: 'commercial-package',
        font: 'mi-unarchive'
    },
    CA: {
        image: 'commercial-auto',
        font: 'mi-local-shipping'
    },
    WC: {
        image: 'workers-comp',
        font: 'mi-work'
    },
    TRVL: {
        image: 'travel',
        font: 'mi-plane'
    },
    PUL: {
        image: 'no-icon',
        font: 'fa-umbrella'
    },
    PL: {
        image: 'professional-liability',
        font: 'mi-healing'
    },
    CL: {
        image: 'cyber-suite',
        font: 'mi-healing'
    },
    LRP: {
        image: 'lessors-risk',
        font: 'mi-store'
    },
    BOP: {
        image: 'business-owners',
        font: 'mi-store'
    },
    default: {
        image: 'no-icon', // Using an existing empty image as default to avoid 404s
        font: 'mi-receipt'
    }
};

const lobKeys = {
    PersonalAuto: 'PA',
    PersonalAutoLine: 'PA',
    auto_per: 'PA',
    Homeowners: 'HO',
    homeowners: 'HO',
    HomeOwners: 'HO',
    HomeownersLine_HOE: 'HO',
    HomeownersLine: 'HO',
    HOPLine: 'HO',
    HOLine: 'HO',
    HOPHomeowners: 'HO',
    GeneralLiability: 'GL',
    GeneralLiabilityLine: 'GL',
    GLLine: 'GL',
    BusinessOwners: 'BO',
    BusinessOwnersLine: 'BO',
    BOPLine: 'BO',
    InlandMarine: 'IM',
    InlandMarineLine: 'IM',
    IMLine: 'IM',
    CommercialProperty: 'CP',
    CommercialPropertyLine: 'CP',
    CPLine: 'CP',
    CommercialAuto: 'CA',
    BusinessAuto: 'CA',
    BusinessAutoLine: 'CA',
    WorkersComp: 'WC',
    WC7WorkersCompLine: 'WC',
    WorkersCompLine: 'WC',
    WC7WorkersComp: 'WC',
    workerscompensation: 'WC',
    CommercialPackage: 'CPKG',
    CommercialPackageLine: 'CPKG',
    travel_perLine: 'TRVL',
    PersonalUmbrellaLine: 'PUL',
    // TDIC LOB's
    PLClaimsMade_TDIC: 'PL',
    PLOccurence_TDIC: 'PL',
    PLCyberLiab_TDIC: 'CL',
    BOPLessorsRisk_TDIC: 'LRP',
    BOPBusinessOwnersPolicy_TDIC: 'BOP',
    ProfLiabClaimsMade: 'PL',
    ProfLiabOccurence: 'PL',
    BOP: 'BOP',
    CyberLiability: 'CL',
    LRP: 'LRP'
};

const tdicSpecificLOBS = ['BusinessOwnersLine', 'GeneralLiabilityLine', 'GeneralLiability', 'BusinessOwners'];

const getNormalisedObject = (lobCode) => {
    const normalisedKey = lobKeys[lobCode] || 'default';
    return normalisedLobIcons[normalisedKey];
};

const getMaterialObject = (lobCode) => {
    const normalisedKey = lobKeys[lobCode] || 'default';
    return materialLobIcons[normalisedKey];
};

const getImageIcon = (lobCode, offeringCode) => {
    const code = (!_.isEmpty(offeringCode)
        && _.includes(tdicSpecificLOBS, lobCode)) ? offeringCode : lobCode;
    return getNormalisedObject(code).image;
};

const getFontIcon = (lobCode) => {
    return getNormalisedObject(lobCode).font;
};

const getMaterialIcon = (lobCode) => {
    return getMaterialObject(lobCode).font;
};

export default {
    getImageIcon: getImageIcon,
    getFontIcon: getFontIcon,
    getMaterialIcon: getMaterialIcon
};
